import asyncComponent from 'app/common/utils/async-component';

const Workbench = asyncComponent(async () => import('./components/index.js'));

export default {
  '/api': {
    components: { main: Workbench },
    '/shape': {
      components: { main: Workbench },
      '/create': {
        components: { main: Workbench }
      },
      '/:name': {
        components: { main: Workbench }
      }
    },
    '/agent/edit/:name': {
      components: { main: Workbench }
    },
    '/agent/create': {
      components: { main: Workbench }
    },
    '/query/:name': {
      components: { main: Workbench }
    },
    '/mutation/:name': {
      components: { main: Workbench }
    }
  }
};
